import axios from "axios";
import { Notification } from "element-ui";
import store from '@/store';
/**
 * 数据请求状态校验
 * @type {AxiosInstance}
 */
const http = axios.create({
  validateStatus: function (status) {
    if (status >= 200 && status < 300) {
      return true;
    } else if (status >= 300) {
      let message = "";
      switch (status) {
        case 400: {
          message = "400 Bad Request";
          break;
        }
        case 405: {
          message = "405 Method Not Allowed";
          break;
        }
        case 503: {
          message = "503 Service Unavailable";
          break;
        }
        case 504: {
          message = "504 Gateway Timeout";
          break;
        }
      }
      Notification.error({
        title: "系统错误",
        message: message,
      });
    }
  },
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  config => {
    let token = store.getters.token || localStorage.getItem('token');
    if (token) {
      config.headers['x-token'] = token;
    }
    return config;
  },
  error => {
    console.log('http.request err::' + error);
    return Promise.reject(error);
  }
);

/**
 * 设置请求超时时间30秒
 * @type {number}
 */
http.defaults.timeout = 30000;

export default http;
